import Collapse from "@material-ui/core/Collapse"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import { SnackbarProvider } from "notistack"
import React, { useEffect } from "react"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import { LoadingContextProvider } from "./contexts/LoadingContext"
import Exception from "./Exception"
import "./global.css"

if (!(localStorage.getItem("teste") || window.location.hostname.includes("localhost"))) {
    console.log = function () {}
    console.warn = function () {}
}

ReactDOM.render(
    <Exception>
        <AlertProvider />
    </Exception>,
    document.getElementById("root")
)

function AlertProvider() {
    const notistackRef = React.createRef()
    const onClickDismiss = key => () => {
        notistackRef.current.closeSnackbar(key)
    }

    useEffect(() => {
        window.dispatchEvent(new CustomEvent("abriSite"))
    }, [])

    return (
        <SnackbarProvider
            maxSnack={1}
            preventDuplicate
            ref={notistackRef}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            TransitionComponent={Collapse}
            action={key => (
                <IconButton onClick={onClickDismiss(key)}>
                    <CloseIcon />
                </IconButton>
            )}
        >
            <BrowserRouter>
                <LoadingContextProvider>
                    <App />
                </LoadingContextProvider>
            </BrowserRouter>
        </SnackbarProvider>
    )
}
